<template>
	<div>
		<input :id="`${group.name}-${index}`"
			   type="checkbox"
			   name="facets"
			   class="state"
			   tabindex="-1"
			   checked />
		<div v-show="!isThereSubgroup(group) && ifMonthFilterRendered && !allItemsInvisible">
			<div class="facet__list__fieldset c-content-sidebar__subgroup-fieldset">
				<label :for="`${group.name}-${index}`" :aria-label="group.name" class="facet__list__label facet-list__label c-content-sidebar__label"></label>
				<nav class="facet__list__select facet__list__select--product-page">
					<slot v-for="facet in group.data">
						<div v-if="facet.visible" class="c-content-sidebar__subgroup-item">
							<span class="c-content-sidebar__subgroup-label"
								  :class="{ 'c-content-sidebar__subgroup-label--expanded': checkIfExpanded(facet.subGroupName) }"
								  @click="setActiveSubgroups(facet.subGroupName)">
								{{ facet.subGroupName }}
							</span>
							<div v-show="checkIfExpanded(facet.subGroupName)">
								<content-facet-item v-for="item in facet.items"
													:key="item.name"
													:facet="item"
													:group="group" />
							</div>
						</div>
					</slot>
				</nav>
			</div>
		</div>
		<div v-show="isThereSubgroup(group) && !ifMonthFilterRendered && !allItemsInvisible">
			<div class="facet__list__fieldset">
				<label :for="`${group.name}-${index}`" :aria-label="group.name" class="facet__list__label facet-list__label c-content-sidebar__label">
					<span class="facet__list__label__text">
						{{ group.name }}
					</span>
				</label>
				<nav class="facet__list__select facet__list__select--product-page">
					<slot v-for="facet in group.data">
						<content-facet-item :key="facet.name"
											:facet="facet"
											:group="group" />
					</slot>
				</nav>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapMutations } from 'vuex';
	import ContentFacetItem from 'shared/components/contentLibrary/contentFacetItem.vue';

	export default {
		name: 'content-facet-group',
		components: { ContentFacetItem },
		props: ['group', 'index'],
		computed: {
			...mapGetters({
				activeSidebarFiltersType: 'getActiveSidebarFiltersType',
				activeSubgroups: 'getActiveSubgroups',
			}),
			ifMonthFilterRendered() {
				return this.activeSidebarFiltersType === 'month';
			},
			allItemsInvisible() {
				return this.group.data.filter((element) => element.visible === true).length === 0;
			}
		},
		methods: {
			...mapMutations(['setActiveSubgroups']),
			isThereSubgroup(group) {
				return !group?.data[0]?.subGroupName;
			},
			checkIfExpanded(subGroupName) {
				return this.activeSubgroups.indexOf(subGroupName) !== -1;
			},
		},
	};
</script>
